export function addNotice(note) {
    return {
        type: 'NOTICE_ADD',
        payload: Promise.resolve(note),
    };
}

export function updateNotice(note) {
    return {
        type: 'NOTICE_UPDATE',
        payload: Promise.resolve(note),
    };
}

export function removeNotice(note) {
    return {
        type: 'NOTICE_REMOVE',
        payload: Promise.resolve(note),
    };
}

export function clearNotice() {
    return {
        type: 'NOTICE_CLEAR',
        payload: Promise.resolve(),
    };
}

export function recordPageView(url) {
    return {
        type: 'RECORD_PAGE_VIEW',
        payload: url,
    };
}

export function recordEvent(event) {
    return {
        type: 'RECORD_EVENT',
        payload: event,
    };
}

export function setCriteria(criteria) {
    return {
        type: 'SET_CRITERIA',
        payload: criteria,
    };
}

export default {
    addNotice,
    updateNotice,
    removeNotice,
    clearNotice,
    recordPageView,
    recordEvent,
    setCriteria
};
